var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app-input", class: _vm.classes }, [
    _c("div", { staticClass: "ui-input-field ui-field ui-outline-field" }, [
      _c("div", { staticClass: "ui-outline-field-wrapper" }, [
        _c("input", {
          attrs: {
            id: _vm.inputId,
            name: _vm.name,
            type: _vm.type,
            min: _vm.type === "number" ? 0 : null,
            required: _vm.required,
            autocomplete: "off",
            pattern: _vm.pattern,
            placeholder: "",
          },
          domProps: { value: _vm.value },
          on: {
            input: function ($event) {
              return _vm.$emit("input", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "ui-outline",
            attrs: { "data-label-lang": _vm.labelLang },
          },
          [
            _c("div", { staticClass: "ui-outline-left" }),
            _vm._v(" "),
            _c("div", { staticClass: "ui-outline-middle" }, [
              _c("label", { attrs: { for: _vm.inputId } }, [
                _vm._v("\n            " + _vm._s(_vm.label) + "\n            "),
                _vm.required
                  ? _c("span", { staticClass: "ui-field-required-marker" })
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui-outline-right" }),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.error
      ? _c("div", { staticClass: "error-label" }, [
          _vm._v(_vm._s(_vm.errorMessage)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }